import { type Dispatch, type SetStateAction } from 'react';

import { faEdit } from '@fortawesome/pro-regular-svg-icons';
import { useIntl } from 'react-intl';

import { parkingManagementMessages } from 'src/features/parkingManagement/utils';
import ConfirmationModal from 'src/registry/components/blocks/ConfirmationModal.tsx';
import { generalMessages } from 'src/utils/messages.ts';

import type { AdditionalServices } from 'src/features/parkingManagement/types/additionalServices.ts';

type AdditionalServiceEnabledStatusModalProps = {
    setIsModalOpen: Dispatch<SetStateAction<boolean>>;
    enableCallback: () => void;
    selectedService: AdditionalServices;
    statusAction: 'activate' | 'deactivate';
};

const AdditionalServiceEnabledStatusModal = ({
    selectedService,
    setIsModalOpen,
    statusAction,
    enableCallback,
}: AdditionalServiceEnabledStatusModalProps) => {
    const { formatMessage } = useIntl();

    const modalTitle =
        statusAction === 'deactivate'
            ? parkingManagementMessages.deactivateModalTitle
            : parkingManagementMessages.activateModalTitle;

    const descriptionStatus =
        statusAction === 'activate'
            ? parkingManagementMessages.activateService
            : parkingManagementMessages.deactivateService;

    const statusChangeSubtitle =
        statusAction === 'activate'
            ? parkingManagementMessages.activateServiceSubtitle
            : parkingManagementMessages.deactivateServiceSubtitle;

    return (
        <ConfirmationModal
            isModalOpen={true}
            setIsModalOpen={setIsModalOpen}
            dialogDetails={{
                title: {
                    ...modalTitle,
                    values: { service: formatMessage(parkingManagementMessages.service).toLowerCase() },
                },
                subTitle: {
                    ...parkingManagementMessages.changeStatusService,
                    values: { status: formatMessage(statusChangeSubtitle), name: selectedService.name },
                },
                icon: faEdit,
                confirmationMessage: {
                    ...parkingManagementMessages.enableStatusConfirmation,
                    values: { name: selectedService.name, status: formatMessage(descriptionStatus).toLowerCase() },
                },
            }}
            callbackButton={{
                variant: 'default',
                buttonTitle: generalMessages.saveChanges,
                callbackFn: () => {
                    if (selectedService) {
                        return (enableCallback(), setIsModalOpen(false));
                    }
                },
            }}
        />
    );
};

export default AdditionalServiceEnabledStatusModal;
